export default async function getShareDesign({storeName, shareId, sku}) {
    let response = await
        fetch(`${process.env.REACT_APP_FILE_SHARE_API}customers/customer-sections?type=share&store_name=${storeName}&share_id=${shareId}&sku=${sku}`)
	
	const returnedResponse = await response.clone().json();
	if (returnedResponse.error) return null
    return  returnedResponse
}
